export default __webpack_public_path__ + "static/Help-you-scaled-e1588324743844-a50956cd71b934fe55b28af0fbfb1698.jpg";